import isArray from 'lodash/isArray'
import modalScrollLockMixin from 'Mixins/modalScrollLock'
import { default as Vue, FunctionalComponentOptions } from 'vue'

interface IVueModalOptions {
  params?: object
  props?: object
  events?: object
}

const defaultParams = {
  adaptive: true,
  clickToClose: false,
  height: '100%',
  pivotY: 0.25,
  transition: 's-pop',
}

const staticParams = {
  scrollable: true,
}

/** Dynamically inject a scroll-lock mixin into an Vue component */
const disableScroll = (ModalComponent: any): FunctionalComponentOptions => {
  return {
    functional: true,

    render(createElement, context) {
      const hasMixins = isArray(ModalComponent.mixins)

      if (hasMixins) {
        ModalComponent.mixins.unshift(modalScrollLockMixin)
      } else {
        ModalComponent.mixins = [ modalScrollLockMixin ]
      }

      return createElement(ModalComponent, { props: context.props, on: context.listeners })
    }
  }
}

/** * A module to assist creating vue-js-modal components. */
export const openModal = (self: any, component: any, options: IVueModalOptions = {}) => {
  const { params, props, events } = options

  const modalComponent = disableScroll(component)
  const _params = Object.assign(defaultParams, params, staticParams)
  const _props = props || null
  const _events = events || null

  self.$modal.show(modalComponent, _props, _params, _events)
}

/** Close all vue-js-modal components */
export const closeAllModals = (self: any) => {
  const container = self.$root.$children.find(component => component.$el.id === 'modals-container')

  container.$data.modals.forEach(modal => {
    const { name } = modal.modalAttrs

    self.$modal.hide(name)
  })
}

export default {
  openModal,
  closeAllModals,
}